
import * as types from "../types/auth"
import {LIKE_NFT_SUCCESS,DISLIKE_NFT_SUCCESS} from "../types/auth";

let initialState = {
    currentUser:"",
    provider: null,
    loading:false,
    errorMessage:'',
    isConnected:false,
    openConnectModal:false,
    user:null
}

export const authReducer = (state=initialState,action)=>{
    let {type,payload}=action;
    switch (type){
        //Register a User
        case types.CONNECT_USER:
            return{
                ...state,
                loading: true,
                openConnectModal: false
            };

        case types.CONNECT_USER_SUCCESS:
            return {
                ...state,
                currentUser: payload.currentUser,
                provider: payload.provider,
                user:payload.userDetail,
                isConnected: true,
                loading: false,
                openConnectModal: false,
            };
        case types.CONNECT_USER_FAILURE:
            return {
                ...state,
                errorMessage: payload,
                openConnectModal: false
            };
        case types.DISCONNECT_USER:
            return{
                ...state,
                loading: true,
                openConnectModal: false
            };
        case types.DISCONNECT_USER_SUCCESS:
            return {
                ...state,
                currentUser: "",
                isConnected: false,
                openConnectModal: false,
                provider: null
            };
        case types.DISCONNECT_USER_FAILURE:
            return {
                ...state,
                errorMessage: payload,
                openConnectModal: false
            };
        case LIKE_NFT_SUCCESS:{
            if(state.isConnected && state.user!==null){
                return {
                    ...state,
                    user:{
                        ...state.user,
                        likedNft:[...state.user.likedNft,payload]
                    }
                }
            }else{
                return {
                    ...state,
                }
            }
        }
        case DISLIKE_NFT_SUCCESS:{
            if(state.isConnected && state.user!==null){
                let newLikedArray = state.user.likedNft.filter(nft=>nft !== payload)
                return {
                    ...state,
                    user:{
                        ...state.user,
                        likedNft:newLikedArray
                    }
                }
            }else{
                return {
                    ...state,
                }
            }
        }
        case types.OPEN_CONNECT_MODAL:
            return {
                ...state,
                openConnectModal: true,
            };
        case types.CLOSE_CONNECT_MODAL:
            return {
                ...state,
                openConnectModal: false
            }
        case types.FETCH_USER:{
            return {
                ...state,
                loading: true
            }
        }
        case types.FETCH_USER_SUCCESS:
            return {
                ...state,
                user:payload,
                loading: false,
            }
        case types.FETCH_USER_FAILURE:
            return {
                ...state,
                errorMessage: payload,
                loading: false
            }
        default :return state;
    }
};